import React from "react";
import "../../style/search.css";
import { Card, Col, Row } from "antd";
import { step_names } from "Components/Coachdashboard/StepNames";
import { stepKeyToPath } from "Components/Baselayout/StaticValues";
import { Link, Redirect, Route, useHistory } from "react-router-dom";

const SearchResults = (props) => {

  const history = useHistory();

  const HighlightMatchTitle = (content, query) => {
    if (!content || !query) return content;

    const regex = new RegExp(`(${query})`, "gi");
    return content.split(regex).map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? <strong key={index}><mark>{part}</mark></strong> : part
    );
  };

  const stripHtml = (html) => {
    // This removes all tags and returns plain text
    return html.replace(/<[^>]+>/g, '');
  };

  const HighlightMatchContent = (content, query, beforeChars = 50) => {
    if (!content || !query) return stripHtml(content);

    const plainText = stripHtml(content);

    const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedQuery, 'i');

    const match = plainText.match(regex);

    if (!match) return plainText; // No match, return plain text

    const matchIndex = match.index;
    const start = Math.max(0, matchIndex - beforeChars);

    const snippet = plainText.substring(start);

    const highlightedSnippet = snippet.replace(new RegExp(`(${escapedQuery})`, 'gi'), '<mark>$1</mark>');

    return `${start > 0 ? '...' : ''}${highlightedSnippet}`;
  }

  return (
    <div style={{ padding: "1% 0" }}>
      <Card
        bordered={false}
        style={{
          margin: "20px !important",
          boxShadow: "0px 3px 6px #00000029",
          borderRadius: "13px",
          textAlign: "left",
          marginRight: "6%",
          marginLeft: `${props.collapsed ? "6%" : "20px"}`,
          padding: "0 2%",
        }}
      >
        <div>
          <Row style={{ padding: "4% 0% 3% 0%" }}>
            <Col
              span={24}
              style={{
                font: "normal normal 300 30px/12px AvenirBook",
                display: "flex",
                alignItems: "center",
              }}
            >
              Search Results
            </Col>
          </Row>
          <p
            style={{
              background: "#FFFFFF 0% 0% no-repeat padding-box",
              border: "1px solid #F0F0F0",
            }}
          ></p>
        </div>
        <div className="search-results-container">
          <div className="results">

            {props.searchLoading && <p className="loading-text">Searching...</p>}
            {(!props.searchLoading && (props.searchResults.length <=0 || props.searchResults.filter((item) => item.content).length <= 0)) && <p className="no-result-text">No Results Found</p>}
            {
              !props.searchLoading && props.searchResults.filter((item) => item.content).map((item, index) => (
                <>
                  <div
                    key={index}
                    // goToLink={ `${window.location.origin}${stepKeyToPath[item.step]}`}
                    onClick={() => {
                      history.push(stepKeyToPath[item.step])
                    }}
                    className="search-result-item"
                  >
                    <p className="result-step">{item.step ? step_names[item.step] : HighlightMatchTitle(item.title, props.searchQuery)}</p>
                    {/* <p className="result-content">{HighlightMatch(item.content, props.searchQuery)}</p> */}
                    <p className="result-content" dangerouslySetInnerHTML={{ __html: HighlightMatchContent(item.content, props.searchQuery) }} />
                  </div>
                </>
              ))
            }
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SearchResults;
